export default __webpack_public_path__ + "static/media/not_settlementEvidence.1eb95951.png";